import React from "react";
import { XMarkIcon } from "@heroicons/react/20/solid";

// Login succeeded, but the invite on that request could not be used.
const InviteNotice = ({ message, onDismiss }) => {
  if (!message) return null;
  return (
    <div
      role="status"
      className="w-full flex items-start justify-between gap-3 px-4 sm:px-6 py-2 bg-[#fff4d6] text-[#7a5300] text-sm border-b border-[#f0d68a]"
    >
      <span>{message}</span>
      {onDismiss && (
        <button onClick={onDismiss} aria-label="Dismiss" className="shrink-0">
          <XMarkIcon className="h-4 w-4" />
        </button>
      )}
    </div>
  );
};

export default InviteNotice;
